module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921132651_T.3b76cf60.jpg";